import React from "react";
import logo from "../img/header_logo.png";

export default function LandingSoldOutMessageOutreach() {

	return (
		<>
			<div className={"content-sold-out"} >

				<img src={logo} style={{width:'100%', marginTop:60}} alt={""} />

				<h1 style={{marginTop:40,marginBottom:40}}>It looks like you do not have any vouchers left to issue or you have entered incorrect information.</h1>

				<h2>Please check the postcode you have entered is correct and that the address is within your campaign area.  If these are correct, please contact your Manager or email <a href="mailto:snipnchip@spca.nz">snipnchip@spca.nz</a> to discuss other options</h2>
				<p>
					Alternatively, please advise the member of the public that you are unable to issue any vouchers at the moment and suggest the following options:
				</p>
				<p>
					<strong>Compare vet clinic prices:</strong>
					The cost can vary between vet clinics, and we recommend calling around to compare prices. There are some vet clinics across the country that provide low cost desexing, as well as payment plans. Each vet clinic will be able to discuss their individual processes and requirements and answer any questions you may have. Generally, kittens will need to be at least 1kg (approximately 10-12 weeks old) before they can be desexed.
				</p>
				<p>
					<strong>Look into other services</strong>: Other organisations or social services in your area may be able to offer desexing services or provide financial assistance. Most of these can be found online through Google.
				</p>
				<p>
					<strong>Check in regularly at 'Help someone desex their pet':</strong> <a href={"https://www.facebook.com/Helpsomeonefixtheirpet/"} target={"_blank"}>Help Someone desex their pet</a> is a great resource page on Facebook that lists desexing options around the country and is updated regularly.
				</p>
				<p>
					Check the SPCA Desexing website to see if another campaign is available in their area:  <a href="https://www.spcadesexing.nz/" target={"_blank"}>https://www.spcadesexing.nz/</a>
				</p>
			</div>
		</>
	)

}
